import { forwardRef } from "react";
import { StyledInput } from "./input.style";
import { InputProps } from "./input.type";

export const Input = forwardRef<HTMLInputElement, InputProps>(({ ...restProps }, ref) => {
    return <StyledInput ref={ref} {...restProps} />;
});

Input.displayName = "Input";
